import { graphql } from "@opensea/graphql"

export const SwapDetailsGasFeeItemFragment = graphql(`
  fragment SwapDetailsGasFeeItem on SwapRouteResult {
    ... on SwapRoute {
      costs {
        costType
        cost {
          usd
        }
      }
    }
  }
`)
